
define('text!fusion/ui/controls/fusion-chart.html',[],function () { return '<div class="fusion-chart bar">\r\n    <div data-bind="html: chartTitleHtml"></div>\r\n\r\n    <div class="chart-container">\r\n        <svg class="chart"></svg>\r\n    </div>\r\n\r\n    <div data-bind="html: chartFooterHtml"></div>\r\n</div>\r\n';});

